import { render, staticRenderFns } from "./ItemStockReserve.vue?vue&type=template&id=2561725c&scoped=true"
import script from "./ItemStockReserve.vue?vue&type=script&lang=js"
export * from "./ItemStockReserve.vue?vue&type=script&lang=js"
import style0 from "./ItemStockReserve.vue?vue&type=style&index=0&id=2561725c&prod&scoped=true&lang=css"
import style1 from "./ItemStockReserve.vue?vue&type=style&index=1&id=2561725c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561725c",
  null
  
)

export default component.exports